import React from 'react';

// Feature item component with icon
const FeatureItem = ({ icon, text, indent = false }) => (
	<li
		className={`mb-[10px] font-glacial text-[18px] font-normal leading-[25.2px] text-[#CFCFCF] flex items-start ${
			indent ? 'ml-[30px]' : ''
		}`}>
		<span className='mt-1 flex-shrink-0'>{icon}</span>
		<span>{text}</span>
	</li>
);

export default FeatureItem;
